import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import {
  EXPORT_MULTIPLE_CLIENT_REPORT_HTML,
  FORCE_IS_LOADING_FALSE_EXPORT_HTML,
} from "../types";
import { EXPORT_MULTIPLE_CLIENT_REPORT_PDF_MESSAGES } from "../constants/exportMultipleClientReportPdfContants";
import {
  exportMultipleClientReportHtmlPending,
  exportMultipleClientReportHtmlFulfilled,
  exportMultipleClientReportHtmlRejected,
} from "../actions";
import { sendApiRequest, notifyError, notifyWarning } from "../../../actions";
import generateError from "../../../utilities/generateError";
import { multipleClientReportHtmlFiltersSelector } from "../selectors";
import { store } from "../../../store/configureStore";
import { isNil } from "ramda";

const notifyAfter10Sec = () => {
  // ensures loading will be gone even if exportMultipleClientReportPdfFulfilled is not called
  store.dispatch({
    type: FORCE_IS_LOADING_FALSE_EXPORT_HTML,
    payload: {},
  });
  return notifyWarning(
    "Your query is taking more than 10 seconds, it will be converted to Mass Action, check it in Reports > Export"
  );
};

const createPayload = (payload) => ({
  method: "get",
  url: "report/GetMultipleClientsReportHtml",
  headers: {
    RequestIsComingFromAMLClientFrontend: "",
  },
  onSuccess: [
    (response) => {
      if (!response.headers["content-disposition"]) {
        return notifyAfter10Sec();
      } else {
        if (!response.data || isNil(response.data)) {
          store.dispatch({
            type: FORCE_IS_LOADING_FALSE_EXPORT_HTML,
            payload: {},
          });
          return notifyWarning(
            EXPORT_MULTIPLE_CLIENT_REPORT_PDF_MESSAGES.NOT_FOUND
          );
        } else {
          return exportMultipleClientReportHtmlFulfilled(response);
        }
      }
    },
  ],
  onError: [
    exportMultipleClientReportHtmlRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});
const meta = {
  api: "pdfApi",
};

const exportMultipleClientReportHtmlEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(EXPORT_MULTIPLE_CLIENT_REPORT_HTML.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      const filters = multipleClientReportHtmlFiltersSelector(state$.value);
      return merge(
        of(exportMultipleClientReportHtmlPending()),
        of(sendApiRequest(createPayload({ ...payload, ...filters }), meta))
      );
    })
  );

export default exportMultipleClientReportHtmlEpic$;



// WEBPACK FOOTER //
// ./src/features/reports/epics/exportMultipleClientReportHtmlEpic.js